import FullCalendar from '@fullcalendar/react'; // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import { AppActions } from 'src/store/AppReducer';
import React, { useEffect, useState } from 'react';
import { DatePicker } from '@mui/lab';
import { Grid, TextField, Typography } from '@mui/material';
import { getLeaveForSelectedMonth } from 'src/services/yearPlannerService';
import { Leave, EmployeeLeave } from 'src/models/leave';
import { useDispatch } from 'react-redux';
import { SnackBar } from 'src/components/SnackBar';
import './Profile.css';
import LeaveEvents from './leaveCalender/leaveEvents';
import { getEmployeeLeaveForSelectedMonth } from 'src/services/leaveService';
import { useParams } from 'react-router-dom';


const EmployeeCalenderView = () => {
    const dispatch = useDispatch();
    const [selectedMonth, setSelectedMonth] = useState(new Date());
    const calendarRef: any = React.createRef();
    const monthPickerRef: any = React.createRef();
    const [loadedEvents, setLoadedEvents] = useState([] as EmployeeLeave[]);
    const { employeeId } = useParams();
    const commonTextColor = '#FFFFFF';

    const annualLeaveColor = '#4285F4';
    const casualLeaveColor = '#34A853';
    const shortLeaveColor = '#FBBC05';
    const sickLeaveColor = '#EA4335';
    const noPayLeaveColor = '#757575';
    const updateLeaveColor = (leaves: EmployeeLeave[]) => {
        (leaves || []).map((item, i) => {
            // if(item.)\
            if (item.typeName === 'Annual Leave') {
                item.textColor = commonTextColor;
                item.color = annualLeaveColor;
                item.title = item.typeName;
                item.halfDayType = item.halfDayType
                item.typeName = item.typeName
                item.dateType = item.dateType
            } else if (item.typeName === 'Casual Leave') {
                item.textColor = commonTextColor;
                item.color = casualLeaveColor;
                item.title = item.typeName;
                item.halfDayType = item.halfDayType
                item.typeName = item.typeName
                item.dateType = item.dateType
            } else if (item.typeName === 'Lieu Leave') {
                item.textColor = commonTextColor;
                item.color = sickLeaveColor;
                item.title = item.typeName;
                item.halfDayType = item.halfDayType
                item.typeName = item.typeName
                item.dateType = item.dateType
            } else if (item.typeName === 'Short Leave') {
                item.textColor = commonTextColor;
                item.color = shortLeaveColor;
                item.title = item.typeName;
                item.halfDayType = item.halfDayType
                item.typeName = item.typeName
                item.dateType = item.dateType
            } else if (item.typeName === 'No Pay Leave') {
                item.textColor = commonTextColor;
                item.color = noPayLeaveColor;
                item.title = item.typeName;
                item.halfDayType = item.halfDayType
                item.typeName = item.typeName
                item.dateType = item.dateType
            }

        });
        return leaves;
    };


    // On Loading the Calander
    useEffect(() => {
        const currentDate = new Date();
        loadCalenderData(currentDate.getMonth() + 1, currentDate.getFullYear());

    }, []);


    const loadCalenderData = (month, year) => {
        dispatch(AppActions.showLoader());
        getEmployeeLeaveForSelectedMonth(
            employeeId,
            month,
            year
        ).then((res) => {
            if (res.data.data.length > 0) {
                const mappedData = res?.data?.data.map(item => ({
                    date: item.calenderDate,
                    summery: item.typeName,
                    type: item.dateType,
                    dayType: item.halfDayType,
                    halfDayType: item.halfDayType,
                    typeName: item.typeName,
                    dateType: item.dateType,
                    color: "",
                    textColor: "",
                    title: ""
                }));
            
            setLoadedEvents(updateLeaveColor(mappedData as EmployeeLeave[]));
            }
            dispatch(AppActions.hideLoader());
        });
    }

    const convertDate = (str: string) => {
        var date = new Date(str),
            mnth = ('0' + (date.getMonth() + 1)).slice(-2),
            day = ('0' + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join('-');
    };

    const renderEvent = (arg: any) => {

        return (
            <LeaveEvents
                date={convertDate(arg.event._instance.range.start)}
                color={arg.textColor}
                backgroundColor={arg.backgroundColor}
                text={arg.event._def.title}
                holidayType={arg.event._def.extendedProps.type}
                dateType={arg.event._def.extendedProps.dateType}
                halfDayType={arg.event._def.extendedProps.halfDayType}
            />
        );

    };

    const mobileCheck = () => {
        if (window.innerWidth >= 768) {
            return false;
        } else {
            return true;
        }
    };

    return (

        <>
            <Grid
                maxWidth="lg"
                sx={{
                    mx: window.innerWidth <= 990 ? 0 : 3,
                    my: window.innerWidth <= 990 ? 0 : 3
                }}
                style={{
                    display: 'flex',
                    backgroundColor: 'white',
                    maxHeight: window.innerHeight,
                    marginTop: '10px',
                    marginBottom: '0px',
                }}
            >
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="stretch"
                    spacing={0}
                >
                    <Grid item xs={11} md={9} sx={{ my: 5 }}
                        style={{
                            marginTop: '0px',
                        }}
                    >

                        <div>
                            <DatePicker
                                openTo={mobileCheck() ? 'day' : 'month'}
                                ref={monthPickerRef}
                                views={mobileCheck() ? ['year', 'month', 'day'] : ['year', 'month']}
                                // label="Year and Month"
                                minDate={new Date('2022-01-01')}
                                maxDate={new Date('2032-12-31')}
                                value={selectedMonth}
                                onChange={(res: any) => {
                                    let date = res as Date;
                                    loadCalenderData(date.getMonth() + 1, date.getFullYear())
                                    setSelectedMonth(res);
                                    let calendarApi = calendarRef.current.getApi();
                                    calendarApi.gotoDate(res);
                                }}
                                renderInput={(params: any) => {
                                    return <TextField {...params} style={{ marginBottom: 10 }} />;
                                }}
                            />
                        </div>
                        <FullCalendar
                            ref={calendarRef}
                            plugins={[dayGridPlugin, interactionPlugin, listPlugin]}
                            views={{
                                newView: {
                                    type: 'dayGridDay'
                                }
                            }}
                            headerToolbar={false}
                            fixedWeekCount={false}
                            initialView={mobileCheck() ? 'newView' : 'dayGridMonth'}
                            showNonCurrentDates={true}
                            selectable={true}
                            events={loadedEvents}
                            eventContent={renderEvent}
                            height={window.innerHeight - window.innerHeight * (40 / 100)}
                            expandRows={true}
                            displayEventTime={false}
                            eventDisplay={'title'}
                            handleWindowResize={true}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={11}
                        md={9}
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            mb: 5
                        }}
                    >

                        <div
                            style={{
                                marginRight: '1rem',
                                color: '#FFFFFF',
                                backgroundColor: '#4285F4',
                                fontSize: '12px',
                                padding: '7px',
                                fontWeight: 'bold',
                                borderRadius: '6px'
                            }}
                        >

                            Annual Leave
                        </div>

                        <div
                            style={{
                                marginRight: '1rem',
                                color: '#FFFFFF',
                                backgroundColor: '#34A853',
                                fontSize: '12px',
                                padding: '7px',
                                fontWeight: 'bold',
                                borderRadius: '6px'
                            }}
                        >
                            Casual Leave
                        </div>

                        <div
                            style={{
                                marginRight: '1rem',
                                color: '#FFFFFF',
                                backgroundColor: ' #FBBC05',
                                fontSize: '12px',
                                padding: '7px',
                                fontWeight: 'bold',
                                borderRadius: '6px'
                            }}
                        >
                            Short Leave
                        </div>

                        <div
                            style={{
                                color: '#FFFFFF',
                                backgroundColor: '#EA4335',
                                fontSize: '12px',
                                padding: '7px',
                                fontWeight: 'bold',
                                borderRadius: '6px'
                            }}
                        >
                            Lieu Leave
                        </div>
                    </Grid>
                </Grid>
                <SnackBar />
            </Grid>
        </>

    );
};
export default EmployeeCalenderView;
